import { css } from '@eti/styles';
import { Card, vars } from '@etg/wings';
import type { TripType } from '@eti/schema-types';
import ItineraryBound from '../../pages/order-details/components/overview/itinerary/drawer/ItineraryBound';
import type { Bound, EventSegment } from './models';

const cardStyles = css`
  border: solid 1px ${vars.colors.divider};
  overflow: hidden;
  padding: 0;
`;

const updateSegmentTypesStructure = ({ segments }: Bound) => {
  return segments.map((segment) => {
    const updatedSegment = { ...segment };
    if (segment?.__typename === 'EventSegment') {
      (updatedSegment as EventSegment).types = segment.types?.map((eventType) => {
        return (eventType as any)?.type;
      });
    }
    return updatedSegment;
  });
};

interface TripItineraryProps {
  bounds: Bound[];
  tripType: TripType;
}

const TripItinerary = ({ bounds, tripType }: TripItineraryProps) => {
  return (
    <>
      {bounds?.map((bound, index: number) => (
        <Card
          className={cardStyles}
          data-testid="orderstatus-trip-details-itinerary-bound"
          key={bound.boundId}
        >
          <ItineraryBound
            boundId={bound.boundId}
            boundIndex={index}
            isSelected
            journeyType={tripType}
            segments={updateSegmentTypesStructure(bound)}
          />
        </Card>
      ))}
    </>
  );
};

export default TripItinerary;
